import { LIFECYCLE_STAGES, SERIES_ACTION_TYPES, GAME_ACTION_TYPES } from './constants';

export const STAGES_ACCESS_MAP = {
  [LIFECYCLE_STAGES.BUILD]: {
    allow: ['MODULE_MANAGEMENT', 'MODULE_DEVELOPMENT'],
  },
  [LIFECYCLE_STAGES.SETTINGS]: {
    allow: ['MODULE_MANAGEMENT', 'MODULE_DEVELOPMENT'],
  },
  [LIFECYCLE_STAGES.PUBLISH]: {
    allow: ['MODULE_SHARING', 'SERIES_MANAGEMENT'],
  },
  [LIFECYCLE_STAGES.INVITE]: {
    allow: ['MODULE_SHARING', 'SERIES_MANAGEMENT'],
  },
};

export const SERIES_ACTIONS_ACTION_MAP = {
  [SERIES_ACTION_TYPES.EDIT_COLLABORATOR_SETTINGS]: {
    allow: ['SERIES_MANAGEMENT'],
  },
  [SERIES_ACTION_TYPES.INVITE_AND_REMOVE_LEARNERS]: {
    allow: ['SERIES_MANAGEMENT', 'MODULE_SHARING'],
  },
  [SERIES_ACTION_TYPES.INVITE_AND_REMOVE_USER_GROUPS]: {
    allow: [
      'SERIES_MANAGEMENT',
      'MODULE_SHARING',
      'GROUP_ADMINISTRATION',
      'CONTENT_SHARING_VIA_GROUP',
      'GROUP_VIEW_ANALYTICS',
    ],
  },
};

export const GAME_ACTIONS_ACCESS_MAP = {
  [GAME_ACTION_TYPES.CREATE]: {
    allow: ['MODULE_DEVELOPMENT'],
  },
  [GAME_ACTION_TYPES.DUPLICATE]: {
    allow: ['MODULE_DEVELOPMENT'],
  },
  [GAME_ACTION_TYPES.DELETE]: {
    allow: ['MODULE_DEVELOPMENT', 'SERIES_MANAGEMENT'],
  },
  [GAME_ACTION_TYPES.ARCHIVE]: {
    allow: ['SERIES_MANAGEMENT'],
  },
  [GAME_ACTION_TYPES.UPDATE_SETTINGS]: {
    allow: ['MODULE_SHARING', 'MODULE_DEVELOPMENT'],
  },
  [GAME_ACTION_TYPES.PUBLISH_AND_UPDATE]: {
    allow: ['MODULE_SHARING'],
  },
};
